import type { TimelineElement } from '../context/TimelineContext'
import type { ConstraintContext } from '../services/aiService'

const toTimestamp = (value: string | null | undefined): number | null => {
  if (!value) return null
  const timestamp = new Date(value).getTime()
  return Number.isFinite(timestamp) ? timestamp : null
}

export const buildTimelineConstraintContext = (
  elements: TimelineElement[],
): ConstraintContext => {
  const totalCost = elements.reduce((elementTotal, element) =>
    elementTotal + element.checklist.reduce((checklistTotal, item) =>
      checklistTotal + (typeof item.actualCost === 'number' ? item.actualCost : 0), 0), 0)
  const starts = elements
    .map((element) => toTimestamp(element.startDate))
    .filter((value): value is number => value !== null)
  const ends = elements
    .map((element) => toTimestamp(element.endDate))
    .filter((value): value is number => value !== null)
  const earliestStart = starts.length > 0 ? Math.min(...starts) : null
  const latestEnd = ends.length > 0 ? Math.max(...ends) : null
  const planningHorizonDays = earliestStart !== null && latestEnd !== null
    ? Math.max(0, Math.ceil((latestEnd - earliestStart) / 86_400_000))
    : null

  return {
    totalCost,
    maxCost: totalCost,
    ...(planningHorizonDays === null ? {} : {
      planningHorizon: planningHorizonDays,
      planningHorizonDays,
    }),
    ...(earliestStart === null ? {} : { earliestStartDate: new Date(earliestStart).toISOString() }),
    ...(latestEnd === null ? {} : { latestEndDate: new Date(latestEnd).toISOString() }),
  }
}
